import { SVGProps } from "svgs/svg.types";

export const ChevronUpIcon: React.FC<SVGProps> = ({
  fillColour,
  svgWidth,
  svgHeight,
}) => {
  return (
    <svg
      width={`${svgWidth || 18}`}
      height={`${svgHeight || 18}`}
      viewBox={`0 0 ${svgWidth || 18} ${svgHeight || 18}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 12L9.5 6L3.5 12"
        stroke={fillColour || "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
